'use client';
import styles from './tooltip.module.css';
import { HoverCard, Portal } from '@chakra-ui/react';
import FontAwesomeIcon from '#/font-awesome';
import { useState } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type ToolTipType = {
	type: 'tag' | 'status';
	icon: IconProp;
	title: string;
	content: string;
};
export const ToolTip = ({ type, icon, title, content }: ToolTipType) => {
	const [open, setOpen] = useState(false);

	const isTag = type === 'tag';

	return (
		<HoverCard.Root size='sm' open={open} onOpenChange={(e) => setOpen(e.open)}>
			<HoverCard.Trigger asChild>
				<div className={`${styles.trigger} ${styles[`trigger-${type}`]}`}>
					<FontAwesomeIcon icon={icon} />
					<p>{title}</p>
				</div>
			</HoverCard.Trigger>
			<Portal>
				<HoverCard.Positioner>
					<HoverCard.Content
						background={isTag ? '#446cb3' : ''}
						maxWidth='15rem'
						borderRadius='0.5rem'
						padding='1rem 0.5rem'
						boxShadow={
							'0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12)'
						}
					>
						<div className={styles.content}>
							<div className={styles[`${type}-content`]}>
								<div className={styles[`${type}-content-title`]}>
									{isTag && <FontAwesomeIcon icon={icon} />}
									<p>{title}</p>
								</div>

								<div className={styles[`${type}-content-body`]}>
									<p>{content}</p>
								</div>
							</div>
						</div>
					</HoverCard.Content>
				</HoverCard.Positioner>
			</Portal>
		</HoverCard.Root>
	);
};
